import { create } from 'zustand';

type ComposeKind = 'place' | 'note' | null;

interface UIState {
  selectedPinId: string | null;
  composing: ComposeKind;
  composingAt: { lat: number; lng: number } | null;
  historyOpen: boolean;
  helpOpen: boolean;
  bucketOpen: boolean;
  toast: { id: number; tone: 'soft' | 'celebrate' | 'warn'; message: string } | null;

  selectPin: (id: string | null) => void;
  startCompose: (opts?: { kind?: 'place' | 'note'; at?: { lat: number; lng: number } }) => void;
  endCompose: () => void;
  openHistory: () => void;
  closeHistory: () => void;
  openHelp: () => void;
  closeHelp: () => void;
  openBucket: () => void;
  closeBucket: () => void;
  showToast: (tone: 'soft' | 'celebrate' | 'warn', message: string) => void;
  dismissToast: () => void;
}

let toastSeq = 0;

export const useUI = create<UIState>((set) => ({
  selectedPinId: null,
  composing: null,
  composingAt: null,
  historyOpen: false,
  helpOpen: false,
  bucketOpen: false,
  toast: null,

  selectPin: (id) => set({ selectedPinId: id }),
  startCompose: (opts) =>
    set({ composing: opts?.kind ?? 'place', composingAt: opts?.at ?? null }),
  endCompose: () => set({ composing: null, composingAt: null }),
  openHistory: () => set({ historyOpen: true }),
  closeHistory: () => set({ historyOpen: false }),
  openHelp: () => set({ helpOpen: true }),
  closeHelp: () => set({ helpOpen: false }),
  openBucket: () => set({ bucketOpen: true }),
  closeBucket: () => set({ bucketOpen: false }),
  showToast: (tone, message) =>
    set({ toast: { id: ++toastSeq, tone, message } }),
  dismissToast: () => set({ toast: null }),
}));
